import ViewUIPlus, { Message, Modal, Notice } from 'view-ui-plus'

const VIEWUI_NESTED_KEYS = [
  'cell',
  'menu',
  'modal',
  'tabs',
  'select',
  'colorPicker',
  'cascader',
  'tree',
  'datePicker',
  'timePicker',
  'typography',
  'space',
  'image',
  'drawer'
]

const IVIEW_DEFAULT_CONFIG = {
  size: '',
  capture: true,
  transfer: true,
  cell: {
    arrow: '',
    customArrow: '',
    arrowSize: ''
  },
  menu: {
    arrow: '',
    customArrow: '',
    arrowSize: ''
  },
  modal: {
    maskClosable: true,
    transfer: true,
    closable: true,
    scrollable: false
  },
  tabs: {
    closeIcon: '',
    customCloseIcon: '',
    closeIconSize: ''
  },
  select: {
    arrow: '',
    customArrow: '',
    arrowSize: '',
    transfer: true
  },
  colorPicker: {
    arrow: '',
    customArrow: '',
    arrowSize: ''
  },
  cascader: {
    arrow: '',
    customArrow: '',
    arrowSize: '',
    itemArrow: '',
    customItemArrow: '',
    itemArrowSize: ''
  },
  tree: {
    arrow: '',
    customArrow: '',
    arrowSize: ''
  },
  datePicker: {
    icon: '',
    customIcon: '',
    iconSize: ''
  },
  timePicker: {
    icon: '',
    customIcon: '',
    iconSize: ''
  },
  typography: {
    copyConfig: '',
    editConfig: '',
    ellipsisConfig: ''
  },
  space: {
    size: ''
  },
  image: {
    toolbar: ''
  },
  // Keep project-level drawer defaults to preserve existing UX.
  drawer: {
    transfer: true,
    maskClosable: true,
    closable: true
  }
}

const buildRuntimeConfig = () => {
  const runtimeViewConfig = {
    ...IVIEW_DEFAULT_CONFIG
  }
  VIEWUI_NESTED_KEYS.forEach((key) => {
    runtimeViewConfig[key] = { ...(IVIEW_DEFAULT_CONFIG[key] || {}) }
  })
  return runtimeViewConfig
}

export function setupIView(app) {
  const runtimeViewConfig = buildRuntimeConfig()

  // Install official plugin so directives/internals are fully registered.
  app.use(ViewUIPlus, runtimeViewConfig)

  // Keep the Vue3 runtime key that view-ui-plus internals read from.
  const currentViewConfig = app.config.globalProperties.$VIEWUI || {}
  const mergedViewConfig = {
    ...currentViewConfig,
    ...runtimeViewConfig
  }
  VIEWUI_NESTED_KEYS.forEach((key) => {
    mergedViewConfig[key] = {
      ...(currentViewConfig[key] || {}),
      ...(runtimeViewConfig[key] || {})
    }
  })

  app.config.globalProperties.$VIEWUI = mergedViewConfig

  // Keep service APIs because existing pages still call them via `this`.
  app.config.globalProperties.$Message = Message
  app.config.globalProperties.$Modal = Modal
  app.config.globalProperties.$Notice = Notice
}
